import gql from 'graphql-tag';

export const ShareMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation experimentalShareMutation($requestBody: ExperimentalShareRequestBodyType!)
		@experimental {
			experimentalShare(requestBody: $requestBody) {
				status
				success
			}
		}
	`;
